<template>
    <div class="px-6">
        <div class="mb-5 flex justify-between" v-show="parseFloat(payload.amount_to_pay)">
            <h3 class="text-smoke-dark text-sm ">
                Send <span class="w-56 truncate" ref="amount">{{ parseFloat(payload.amount_to_pay) }}</span
                >BTC to Wallet Address:
            </h3>
            <div role="button" @click="copyToClipboard('amount', 'total amount')">
                <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="#C0CCDA"
                    xmlns="http://www.w3.org/2000/svg"
                    class="ml-3"
                >
                    <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M6 10V9C6 7.346 7.346 6 9 6H10V2.667C10 2.299 9.701 2 9.333 2H2.667C2.299 2 2 2.299 2 2.667V9.333C2 9.701 2.299 10 2.667 10H6ZM6 12H2.667C1.196 12 0 10.804 0 9.333V2.667C0 1.196 1.196 0 2.667 0H9.333C10.804 0 12 1.196 12 2.667V6H15C16.654 6 18 7.346 18 9V15C18 16.654 16.654 18 15 18H9C7.346 18 6 16.654 6 15V12ZM8 9C8 8.449 8.449 8 9 8H15C15.552 8 16 8.449 16 9V15C16 15.551 15.552 16 15 16H9C8.449 16 8 15.551 8 15V9Z"
                    />
                </svg>
            </div>
        </div>
        <div class="bg-snow-300 rounded-lg flex flex-col items-center p-6 mb-8">
            <template v-if="type === 'btc'">
                <template v-if="Object.entries(payload).length">
                    <div class="w-24 mb-5">
                        <img
                            :src="`https://blockchain.info/qr?data=${payload.address}&size=600`"
                            alt=""
                            class="w-full"
                        />
                    </div>
                </template>
                <template v-else>
                    <div class="img_skeleton"></div>
                </template>
                <div class="flex items-center">
                    <template v-if="Object.entries(payload).length">
                        <p class="text-grey-300 text-sm w-56 truncate" ref="address">{{ payload.address }}</p>
                    </template>
                    <template v-else>
                        <div class="skeleton"></div>
                    </template>
                    <div role="button" @click="copyToClipboard('address', 'BTC Address')">
                        <svg
                            width="18"
                            height="18"
                            viewBox="0 0 18 18"
                            fill="#C0CCDA"
                            xmlns="http://www.w3.org/2000/svg"
                            class="ml-3"
                        >
                            <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M6 10V9C6 7.346 7.346 6 9 6H10V2.667C10 2.299 9.701 2 9.333 2H2.667C2.299 2 2 2.299 2 2.667V9.333C2 9.701 2.299 10 2.667 10H6ZM6 12H2.667C1.196 12 0 10.804 0 9.333V2.667C0 1.196 1.196 0 2.667 0H9.333C10.804 0 12 1.196 12 2.667V6H15C16.654 6 18 7.346 18 9V15C18 16.654 16.654 18 15 18H9C7.346 18 6 16.654 6 15V12ZM8 9C8 8.449 8.449 8 9 8H15C15.552 8 16 8.449 16 9V15C16 15.551 15.552 16 15 16H9C8.449 16 8 15.551 8 15V9Z"
                            />
                        </svg>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="flex items-center w-full justify-center h-32">
                    <button
                        @click="$emit('set-type')"
                        class="text-orange text-lg font-medium py-4 px-16 rounded-lg bg-orange-pale md:w-auto w-full"
                    >
                        Pay with Bitcoin
                    </button>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
    name: 'bitcoin-pay',
    props: {
        amount: Number,
        type: String,
        payload: Object,
    },

    methods: {
        ...mapActions('Message', {
            setMessage: 'SET_MESSAGE',
        }),

        copyToClipboard(content, item) {
            const textToCopy = this.$refs[content].textContent
            const inputField = document.createElement('input')

            inputField.value = textToCopy
            document.body.appendChild(inputField)

            inputField.select()
            document.execCommand('copy')
            inputField.remove()

            this.setMessage('Successfully copied ' + item + ' to clipboard')
        },
    },
}
</script>

<style scoped>
.img_skeleton {
    content: ' ';
    width: 160px;
    height: 100px;
    border-radius: 4px;
    background-color: #ddd;
    opacity: 0.6;
    margin-bottom: 10px;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}

.skeleton {
    content: ' ';
    width: 250px;
    height: 25px;
    border-radius: 4px;
    background-color: #ddd;
    opacity: 0.6;
    margin: 10px 0;
    animation: pulse-bg 1s ease-in-out infinite normal both;
}
</style>
